import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        gap: 16,
        padding: 24,
        textAlign: 'center',
        fontFamily: 'var(--font-sans)',
      }}
    >
      <div className="oh-spectrum oh-spectrum--smooth" style={{ width: 48, height: 4 }} />
      <h1 style={{ fontSize: 'var(--fs-h1)', fontWeight: 800, color: 'var(--text-strong)', margin: 0 }}>
        404
      </h1>
      <p style={{ color: 'var(--text-muted)', fontSize: 'var(--fs-body)', margin: 0 }}>
        This page doesn't exist.
      </p>
      <Link
        to="/"
        style={{
          padding: '10px 24px',
          borderRadius: 'var(--radius-pill)',
          background: 'var(--brand)',
          color: 'var(--on-brand)',
          fontWeight: 600,
          fontSize: 'var(--fs-sm)',
          textDecoration: 'none',
        }}
      >
        Go home
      </Link>
    </div>
  )
}
